"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_charity__giving__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apps_ic",
    "data-name": "Apps ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.21,
    y1: -1093.57,
    x2: 176.18,
    y2: -1093.57,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -976)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi",
    "data-name": "Apps ic hi"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.83,167.79h33a35.91,35.91,0,0,0,13.16-2c.34-.13.67-.26,1-.41,1.66-.71,13.22-6.7,31.94-16.4,14.22-7.37,30.35-15.73,38.85-20a11.62,11.62,0,0,0-10.13-20.91l-2,.94a12.14,12.14,0,0,0-.75-1.37,11.67,11.67,0,0,0-14.7-4.33l-8.66,4a11.65,11.65,0,0,0-15.41-5.62l-30.92,14.2c-2.14-.43-3.91-.8-5.08-1-3.95-.84-8.49-2.18-11.6-3.16a34.84,34.84,0,0,0-26.27,2.12c-9.55,4.94-16.42,13.69-20.44,26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "aa3f1b6b-f95a-429b-8220-62574db5c8cb",
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.93,128.48a7.92,7.92,0,0,1-2.29,4.64A8,8,0,0,1,114,135.4L82.49,135c-.11,0-9.88-.43-15.15,4.37l-.4.36h0a.74.74,0,0,0-.26.56.76.76,0,0,0,.75.77h0a.73.73,0,0,0,.59-.3h0c5.4-4.16,14.33-3.78,14.44-3.77l31.48.4a8,8,0,0,0,5.67-2.28,7.86,7.86,0,0,0,2.36-5.65A8,8,0,0,0,121.93,128.48Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,117.18a11.68,11.68,0,0,1-.38,2.19,12.11,12.11,0,0,1-6.21,7.59c-8.46,4.27-24.48,12.57-38.61,19.9l-.25.13c-18.72,9.7-30.29,15.69-32,16.41l-1,.42a36.44,36.44,0,0,1-13.34,2H46.33v2H84.42a36.44,36.44,0,0,0,13.34-2c.34-.13.67-.27,1-.42,1.68-.72,13.25-6.71,32-16.41l.25-.13c14.13-7.33,30.15-15.63,38.61-19.9a12,12,0,0,0,6.59-11.78Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,175.63a4,4,0,0,1-2.83-1.17L17.34,144.68A4,4,0,0,1,23,139h0l29.83,29.8A4,4,0,0,1,50,175.63Z",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.83,172.46a4,4,0,0,1-5.66,0h0L17.34,142.68a4,4,0,0,1-1-1.83,4,4,0,0,0,1,3.83l29.83,29.78a4,4,0,0,0,6.69-3.83A4.07,4.07,0,0,1,52.83,172.46Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.200000002980232
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.76,121.73a11.63,11.63,0,0,0-16.09-13.63l-2,.94a12.14,12.14,0,0,0-.75-1.37,11.67,11.67,0,0,0-14.7-4.33l-8.66,4a11.65,11.65,0,0,0-15.41-5.62L87.21,115.89l.4.11,71.5,18.48c4.17-2.15,7.86-4,10.69-5.47A11.63,11.63,0,0,0,175.76,121.73Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,107.42,117,123.59l3.41.88L157.62,109a12.14,12.14,0,0,0-.75-1.37Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,105.69,98.73,118.87l3.41.88,31.37-12.43a13.53,13.53,0,0,0-.71-1.29A2.62,2.62,0,0,0,132.56,105.69Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "c1056ed4-fd09-4cf4-bd4e-5d2fa533ee99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc710075-84e1-47a6-a77d-68fcb5409a28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e391f3a4-079c-4ef3-ad18-c32ed02fe51a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bb17cb53-f95c-4280-b6e6-f74affe33b2e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "de6487e3-9b0b-4f60-b2b9-04a7d497a093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b7dbb9ef-79c9-42e7-902d-ac937742740f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c1a3ef69-2b15-47e5-9c0d-cd312908b395"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.49,96.28a2,2,0,0,1-1.25-.44,162,162,0,0,1-18.76-18C66.75,63.42,59.91,50.22,59.14,38.6A20.73,20.73,0,0,1,64.87,23,23.54,23.54,0,0,1,82,15.5a22.78,22.78,0,0,1,18,8.94,22,22,0,0,1,17.5-8.94c12.28,0,22.28,10.48,22.32,23.38.14,2,.81,25.22-39.1,57A2.1,2.1,0,0,1,99.49,96.28Z",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.75,94.83a2,2,0,0,1-2.53,0,161.81,161.81,0,0,1-18.74-18C66.75,62.41,59.91,49.21,59.14,37.59v1c.77,11.61,7.61,24.82,20.34,39.2a162,162,0,0,0,18.76,18,2,2,0,0,0,2.53,0C139.31,65.18,140,42.46,139.88,39.16,139.69,44.78,136.53,66.37,100.75,94.83Z",
    style: {
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }))))))))))));
}

var _default = ic_charity__giving__dark;
exports.default = _default;